import React, {
  useCallback,
  useMemo,
  useRef,
  useEffect,
  useState,
} from "react";
import { connect, useSelector } from "react-redux";
import AreaPlot from "./AreaPlot";
import { Text } from "../../styles/Global";
import {
  usePlayerDuprDoublesMutation,
  usePlayerDuprSinglesMutation,
  usePlayerSPRMutation,
} from "../../services/playerApi";
import SkeletonLoader from "../../components/SkeletonLoader";
import { setChartData } from "../../features/player/chartDataSlice";

const mapDispatch = { setChartData };

const SPRChart = ({
  FormatTimestamps,
  requestBody,
  setChartData,
  sport,
  type,
}) => {
  const savedChartData = useSelector((state) => state.chartData.playerSPR);
  const [data, setData] = useState(savedChartData);
  //console.log("savedChartData: ", savedChartData);
  const [
    getPlayerSPR,
    { data: playerSPRData, error: playerSPRError, isLoading: playerSPRLoading },
  ] = usePlayerSPRMutation();
  const [
    getDuprDoubles,
    {
      data: playerDuprDoublesData,
      error: playerDuprDoublesError,
      isLoading: playerDuprDoublesLoading,
    },
  ] = usePlayerDuprDoublesMutation();
  const [
    getDuprSingles,
    {
      data: playerDuprSinglesData,
      error: playerDuprSinglesError,
      isLoading: playerDuprSinglesLoading,
    },
  ] = usePlayerDuprSinglesMutation();
  useEffect(() => {
    //console.log("getting Player SPR");
    if (sport === "pickleball") {
      if (type === "duprSingles") {
        console.log("gettingDuprSingles");
        getDuprSingles(requestBody);
      } else {
        console.log("gettingDuprDoubles");
        getDuprDoubles(requestBody);
      }
    } else {
      getPlayerSPR(requestBody);
    }
  }, []);
  useEffect(() => {
    if (playerSPRData) {
      setChartData({ playerSPR: playerSPRData });
      setData(playerSPRData);
    } else if (playerDuprDoublesData) {
      setChartData({ playerRank: playerDuprDoublesData });
      setData(playerDuprDoublesData);
    } else if (playerDuprSinglesData) {
      setChartData({ playerRank: playerDuprSinglesData });
      setData(playerDuprSinglesData);
    }
  }, [playerSPRData, playerDuprDoublesData, playerDuprSinglesData]);
  console.log("playerDuprDoublesData: ", playerDuprDoublesData);
  console.log("playerDuprSinglesData: ", playerDuprSinglesData);
  return data ? (
    <div>
      {data && data.chart.length ? (
        <AreaPlot
          autoHeight={true}
          type={sport === "pickleball" ? "dupr" : "spr"}
          x="timestamp"
          y={sport === "pickleball" ? "dupr" : "spr"}
          data={FormatTimestamps(data.chart)}
        />
      ) : (
        <div
          style={{
            textAlign: "center",
            alignSelf: "center",
            marginTop: 25,
          }}
        >
          <Text>No SPR Data available yet</Text>
        </div>
      )}
    </div>
  ) : (
    <SkeletonLoader h1={200} />
  );
};
export default connect(null, mapDispatch)(SPRChart);
